import script from "./ConfigEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigEdit.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigEdit.vue?vue&type=style&index=0&id=b69768fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b69768fc"]])

export default __exports__